import { getPatternStyles, patternFns } from '../helpers.mjs';
import { css } from '../css/index.mjs';

const listConfig = {
transform(props) {
  const { disablePadding, ...rest } = props;
  return {
    listStyle: "none",
    margin: "0",
    py: disablePadding ? "0" : "2",
    px: "0",
    position: "relative",
    ...rest
  };
},
defaultValues:{disablePadding:false}}

export const getListStyle = (styles = {}) => {
  const _styles = getPatternStyles(listConfig, styles)
  return listConfig.transform(_styles, patternFns)
}

export const list = (styles) => css(getListStyle(styles))
list.raw = getListStyle